import ContentHelper from 'mixins/slice-helper';

const slice = {
  props: ['slice'],
  mixins: [ContentHelper],

  computed: {
    content () {
      if (this.slice.primary.content) {
        return this.contentAsHtml(this.slice.primary.content);
      }
    },

    body () {
      if (this.slice.primary.body) {
        return this.contentAsHtml(this.slice.primary.body);
      }
    },

    title () {
      return this.sliceData.title[0].text;
    },

    sliceData () {
      return this.slice && this.slice.primary;
    }
  },

  methods: {

  }
};

export default slice;
